document.addEventListener('turbolinks:load', () => {
  const range = document.querySelector('input[type="range"]');
  if(range){
    // when range value changes then print value
    range.addEventListener('change', (e) => {
      console.log(range.value);
    })

  }
})